/* 配置公用vant组件 */
import Vue from 'vue';
import 'vant/lib/button/style';
import {
  Swipe,
  SwipeItem,
  Lazyload,
  ImagePreview,
  Toast,
  Field,
  Cell,
  CellGroup,
  Tabbar,
  TabbarItem,
  Picker,
  Popup,
  Button,
  RadioGroup,
  Radio,
  TreeSelect,
  Uploader,
  CountDown,
  Icon,
  List,
  Overlay,
  PasswordInput, NumberKeyboard,
  Tab,
  Tabs,
  Stepper,
  AddressEdit,
  SwitchCell,
  PullRefresh,
  Sticky,
  Dialog,
} from 'vant';

Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Lazyload);
Vue.use(ImagePreview);
Vue.prototype.$imagePreview = ImagePreview;
Vue.use(Toast);
Vue.prototype.$toast = Toast;
Vue.use(Field);
Vue.use(Cell).use(CellGroup);
Vue.use(Tabbar).use(TabbarItem);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Button);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Uploader);
Vue.use(Icon);
Vue.use(List);
Vue.use(Overlay);
Vue.use(PasswordInput).use(NumberKeyboard);
Vue.use(Tab).use(Tabs);
Vue.use(Stepper);
Vue.use(AddressEdit);
Vue.use(SwitchCell);
Vue.use(PullRefresh);
Vue.use(Sticky);
Vue.use(Dialog);